import 'assets/vendors/flag/sprite-flags-24x24.css';
import 'assets/vendors/gaxon/styles.css';
import 'assets/vendors/flaticon/flaticon.css';
import './noir-pro/styles.css';
